export function isAndroid() {
  const u = navigator.userAgent;
  if (u.indexOf("Android") > -1 || u.indexOf("Linux") > -1) {
    return true;
  }
  return false;
}

export function isIos() {
  const u = navigator.userAgent;
  if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
    return true;
  }
  return false;
}

export function isMacOS() {
  const userAgent = window.navigator.userAgent;

  return userAgent.indexOf("Macintosh") !== -1;
}

export function isMobileDevice() {
  return isAndroid() || isIos();
}

export function isWechat() {
  const u = navigator.userAgent;
  if (u.toLowerCase().indexOf("micromessenger") !== -1) {
    return true;
  }
  return false;
}

export function isIphoneX() {
  return (
    /iphone/gi.test(window.navigator.userAgent) &&
    window.devicePixelRatio &&
    (window.devicePixelRatio === 2 || window.devicePixelRatio === 3) &&
    window.screen.width === 375 &&
    window.screen.height === 812
  );
}

export function isIphoneXSMax() {
  return (
    /iphone/gi.test(window.navigator.userAgent) &&
    window.devicePixelRatio &&
    window.devicePixelRatio === 3 &&
    window.screen.width === 414 &&
    window.screen.height === 896
  );
}

export function isIphoneXR() {
  return (
    /iphone/gi.test(window.navigator.userAgent) &&
    window.devicePixelRatio &&
    window.devicePixelRatio === 2 &&
    window.screen.width === 414 &&
    window.screen.height === 896
  );
}

export function isIphone12Mini() {
  return (
    /iphone/gi.test(window.navigator.userAgent) &&
    window.devicePixelRatio &&
    window.devicePixelRatio === 3 &&
    window.screen.width === 360 &&
    window.screen.height === 780
  );
}

export function isIphone12() {
  return (
    /iphone/gi.test(window.navigator.userAgent) &&
    window.devicePixelRatio &&
    window.devicePixelRatio === 3 &&
    window.screen.width === 390 &&
    window.screen.height === 844
  );
}

export function isIphone12ProMax() {
  return (
    /iphone/gi.test(window.navigator.userAgent) &&
    window.devicePixelRatio &&
    window.devicePixelRatio === 3 &&
    window.screen.width === 428 &&
    window.screen.height === 926
  );
}

export function isFringePhone() {
  return isIphoneX() || isIphoneXSMax() || isIphoneXR() || isIphone12Mini() || isIphone12() || isIphone12ProMax();
}

export function isPhone(value) {
  const phoneReg = /^1[0-9]{10}$/;
  return phoneReg.test(value);
}

export function isEmail(value) {
  const emailReg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,})+$/;
  return emailReg.test(value);
}

export function isNumber(value) {
  const numberReg = /^\d+$/;
  return numberReg.test(value);
}

export function getBytesLength(str) {
  let totalLength = 0;
  for (let i = 0; i < str.length; i++) {
    if (str.charCodeAt(i) > 255) {
      totalLength += 2;
    } else {
      totalLength += 1;
    }
  }
  return totalLength;
}

export function openWindow(url: string) {
  const _window = window.open();
  setTimeout(() => {
    _window.location = url;
  });
}

export function splitCountryCodeAndMobile(value: string) {
  let country_code;
  let mobile = value;
  if (value.startsWith("+")) {
    [country_code, mobile] = value?.split(" ");
  }
  return [country_code, mobile];
}
